import { Toggle as TogglePrimitive } from "radix-ui"
import type { ComponentProps } from "react"
import { cn } from "cn"

/**
 * Figma bündelt Zustand und Aktivierung in einer `Variant`-Achse
 * (`default`, `default disabled`, `selected`, `selected disabled`). Das wird auf
 * die nativen Radix-Zustände abgebildet: `pressed` (= selected) und `disabled`.
 */
export type ToggleProps = ComponentProps<typeof TogglePrimitive.Root>

function Toggle({ className, ...props }: ToggleProps) {
  return (
    <TogglePrimitive.Root
      data-slot="toggle"
      className={cn(
        "inline-flex size-9 shrink-0 cursor-pointer items-center justify-center overflow-clip rounded-full border-0 bg-neutrals-v2-200 text-sm leading-5 font-semibold whitespace-nowrap text-labels-primary transition-colors outline-none",
        "focus-visible:ring-2 focus-visible:ring-neutrals-v2-1000",
        "data-[state=on]:bg-brand-red-200 data-[state=on]:text-neutrals-v2-100",
        "disabled:cursor-not-allowed disabled:text-neutrals-v2-600",
        "disabled:data-[state=on]:bg-brand-red-100 disabled:data-[state=on]:text-neutrals-v2-100",
        className
      )}
      {...props}
    />
  )
}

export { Toggle }
